// Copyright ©️ 2026 eVolve MEP, LLC

import EvolveLogo from 'assets/images/image-src/e-volve-logo.svg?react';
import BendCreator from 'assets/images/image-src/welcome-screens/bend-creator.png';
import BillOfMaterials from 'assets/images/image-src/welcome-screens/bill-of-materials.png';
import ModelBrowser from 'assets/images/image-src/welcome-screens/model-browser.png';
import ShippingOrders from 'assets/images/image-src/welcome-screens/shipping-orders.png';
import Spooling from 'assets/images/image-src/welcome-screens/spooling.png';
import Tasks from 'assets/images/image-src/welcome-screens/tasks.png';
import TimeTracking from 'assets/images/image-src/welcome-screens/time-tracking.png';
import WorkOrders from 'assets/images/image-src/welcome-screens/work-orders.png';

export { EvolveLogo };

export const WelcomeScreenImages = {
  WorkOrders,
  BendCreator,
  BillOfMaterials,
  ModelBrowser,
  ShippingOrders,
  Spooling,
  Tasks,
  TimeTracking,
};
